import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { ref, watchEffect } from 'vue';
import {
  Map,
  Icon,
  GoogleMapsRoute,
} from '@components';
import { useRoutesStore } from '@components/stores';
import { mapRoutesToMapRoutes, mapPortToMapPort } from '@components/maps';
import { MapPort } from '@components/types';
import {
  InfoWindow,
} from 'vue3-google-map';
import { getMapBounds } from '@components/helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'MapApp',
  props: {
    isStatic: { type: Boolean },
    routeCode: {}
  },
  setup(__props: any) {

const props = __props;

const routeStore = useRoutesStore();
const mapRef = ref();

const route = ref<GoogleMapsRoute>();
const ports = ref<Array<MapPort>>();

routeStore.requestRouteMapByRouteCode(props.routeCode);

const getPortOffset = () => {
  const gmap = mapRef.value?.map;
  const offset = -25 + (gmap ? gmap.getZoom() : 0);
  return offset;
};

watchEffect(() => {
  if (routeStore.routeInfoMap) {
    route.value = mapRoutesToMapRoutes(routeStore.routeInfoMap);
    ports.value = routeStore.routeInfoMap.ports.map(mapPortToMapPort);

    const gmap = mapRef.value?.map;

    if (!gmap) return;

    const lats = ports.value.map((p) => p.options.position.lat);
    const lngs = ports.value.map((p) => p.options.position.lng);
    gmap.fitBounds(
      getMapBounds(lats, lngs),
      70,
    );
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Map), {
    center:  { lat: 55.609867, lng: -4.958157 },
    routes: route.value ? [route.value] : undefined,
    ports: ports.value,
    "is-static": _ctx.isStatic,
    class: "staticMap",
    onUpdateMapRef: _cache[0] || (_cache[0] = (map) => mapRef.value = map)
  }, {
    customPortIcon: _withCtx(() => [
      _createVNode(_unref(Icon), {
        "icon-name": "mapMarker",
        lg: ""
      })
    ]),
    portInfoWindow: _withCtx(() => [
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ports.value, (port, index) => {
          return (_openBlock(), _createBlock(_unref(InfoWindow), {
            key: index,
            class: "portInfoWindow",
            options: {
            position: {
              lat: port.options.position.lat,
              lng: port.options.position.lng,
            },
            pixelOffset: {
              width: 0,
              height: getPortOffset(),
            },
          }
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString(port.name), 1)
            ]),
            _: 2
          }, 1032, ["options"]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["routes", "ports", "is-static"]))
}
}

})